module.exports = __webpack_public_path__ + "static/media/tada.e3b222a6.mp3";